import React from "react";
import styles from "./style.scss";

interface Props {
  question: string;
  questionOptimization?: string;
  questionAt?: string;
}

// ユーザ質問コンポーネント
export const UserQuestion: React.FC<Props> = ({
  question,
  questionOptimization,
  questionAt
}) => {
  return (
    <div className={styles.userQuestion}>
      <div className={styles.original}>{question}</div>
      {questionOptimization && (
        <>
          <div className={styles.optimization}>
            <span className={styles.tips}>
              以下のように質問を最適化して回答します
            </span>
            <span className={styles.optimizationText}>
              {questionOptimization}
            </span>
          </div>
          <div className={styles.questionAt}>{questionAt}</div>
        </>
      )}
    </div>
  );
};
